var _class, _temp, _initialiseProps;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { createContext, Component } from "react";

import Paper from "@material-ui/core/Paper";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import Delete from "@material-ui/icons/Delete";
import Edit from "@material-ui/icons/Edit";
import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";
import AddCircle from "@material-ui/icons/AddCircle";
import IconButton from "@material-ui/core/IconButton";
import SelectWidget from "./SelectWidget";
import TextFieldWidget from "./TextFieldWidget";
import { DataTypeProvider } from "@devexpress/dx-react-grid";

import { EditingState } from "@devexpress/dx-react-grid";
import { Grid, Table, TableEditColumn, TableEditRow, TableHeaderRow } from "@devexpress/dx-react-grid-material-ui";
import { withStyles } from "@material-ui/styles";

var tableEditableWidgetStyles = function tableEditableWidgetStyles() {
  return {
    container: {
      overflowX: "auto"
    }
  };
};

var AddButton = function AddButton(_ref) {
  var onExecute = _ref.onExecute;
  return React.createElement(
    "div",
    { style: { textAlign: "left" } },
    React.createElement(
      IconButton,
      { onClick: onExecute, title: "Add" },
      React.createElement(AddCircle, null)
    )
  );
};

var EditButton = function EditButton(_ref2) {
  var onExecute = _ref2.onExecute;
  return React.createElement(
    IconButton,
    { onClick: onExecute, title: "Editar" },
    React.createElement(Edit, null)
  );
};

var DeleteButton = function DeleteButton(_ref3) {
  var onExecute = _ref3.onExecute;
  return React.createElement(
    IconButton,
    { onClick: onExecute, title: "Remover" },
    React.createElement(Delete, null)
  );
};

var CommitButton = function CommitButton(_ref4) {
  var onExecute = _ref4.onExecute;
  return React.createElement(
    IconButton,
    { onClick: onExecute, title: "Salvar" },
    React.createElement(Check, null)
  );
};

var CancelButton = function CancelButton(_ref5) {
  var onExecute = _ref5.onExecute;
  return React.createElement(
    IconButton,
    { onClick: onExecute, title: "Cancelar" },
    React.createElement(Close, null)
  );
};

var getSelectWidgetSchema = function getSelectWidgetSchema(element) {
  return {
    operation: element.operation,
    service: element.service,
    metadata: {
      mappingName: element.mappingName,
      mappingValue: element.mappingValue,
      readonly: element.readonly,
      required: element.required
    },
    items: { titleMap: element.titleMap }
  };
};

var Select = function Select(props) {
  var element = props.element,
      _props$options = props.options,
      options = _props$options === undefined ? {} : _props$options,
      gridProperties = props.gridProperties;


  var schema = getSelectWidgetSchema(element);

  return React.createElement(SelectWidget, {
    id: gridProperties.column.name,
    onChange: gridProperties.onValueChange,
    schema: schema,
    options: options,
    value: gridProperties.value
  });
};

var Input = function Input(props) {
  var element = props.element,
      gridProperties = props.gridProperties;


  var schema = {
    metadata: {
      readonly: element.readonly,
      required: element.required
    },
    type: element.type === "input-number" ? "number" : "text"
  };

  return React.createElement(TextFieldWidget, {
    options: {},
    id: gridProperties.column.name,
    schema: schema,
    value: gridProperties.value,
    onChange: gridProperties.onValueChange
  });
};

var commandComponents = {
  add: AddButton,
  edit: EditButton,
  delete: DeleteButton,
  commit: CommitButton,
  cancel: CancelButton,
  select: Select,
  input: Input,
  "input-number": Input
};

var Command = function Command(_ref6) {
  var id = _ref6.id,
      onExecute = _ref6.onExecute;

  var CommandButton = commandComponents[id];
  return React.createElement(CommandButton, { onExecute: onExecute });
};

var getRowId = function getRowId(row) {
  return row.index;
};

var editColumnMessages = {
  addCommand: "Adicionar",
  editCommand: "Editar",
  deleteCommand: "Remover",
  commitCommand: "Salvar",
  cancelCommand: "Cancelar"
};

var TableEditableWidget = (_temp = _class = function (_Component) {
  _inherits(TableEditableWidget, _Component);

  function TableEditableWidget(props) {
    _classCallCheck(this, TableEditableWidget);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    var value = props.formData || [];

    value.map(function (item, index) {
      return item.index = index;
    });

    _this.state = {
      tableLines: value
    };
    return _this;
  }

  TableEditableWidget.prototype.render = function render() {
    var _props = this.props,
        classes = _props.classes,
        schema = _props.schema;
    var tableLines = this.state.tableLines;


    var columns = this.configureColumns(schema);

    return React.createElement(
      "section",
      null,
      React.createElement(
        FormControl,
        { component: "fieldset" },
        React.createElement(
          FormLabel,
          { component: "legend", style: { padding: "6px 0 7px" } },
          schema.metadata.title
        )
      ),
      React.createElement(
        FormGroup,
        { className: classes.container },
        React.createElement(
          Paper,
          null,
          React.createElement(
            Grid,
            { rows: tableLines, columns: columns, getRowId: getRowId },
            React.createElement(DataTypeProvider, {
              formatterComponent: this.SelectFormatter,
              "for": this.getSelectColumns()
            }),
            React.createElement(EditingState, { onCommitChanges: this.commitChanges }),
            React.createElement(Table, { messages: { noData: "Sem dados" } }),
            React.createElement(TableHeaderRow, null),
            React.createElement(TableEditRow, { cellComponent: this.EditCell }),
            !schema.metadata.readonly && React.createElement(TableEditColumn, {
              width: 120,
              showAddCommand: true,
              showEditCommand: true,
              showDeleteCommand: true,
              commandComponent: Command
            })
          )
        )
      )
    );
  };

  return TableEditableWidget;
}(Component), _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getSelectColumns = function () {
    var elements = _this2.props.schema.elements;


    var selectColumns = [];

    elements.forEach(function (element) {
      if (element.type === "select") selectColumns.push(element.key);
    });

    return selectColumns;
  };

  this.configureColumns = function (_ref7) {
    var elements = _ref7.elements;

    return elements.reduce(function (acc, item) {
      var name = item.key,
          title = item.title;

      return [].concat(acc, [{ name: name, title: title }]);
    }, []);
  };

  this.commitChanges = function (_ref8) {
    var added = _ref8.added,
        changed = _ref8.changed,
        deleted = _ref8.deleted;

    var tableLines = _this2.state.tableLines.slice();
    if (changed) {
      Object.keys(changed).map(function (index) {
        if (changed[index]) {
          Object.keys(changed[index]).map(function (key) {
            return tableLines[index][key] = changed[index][key];
          });
        }
      });
    }

    if (deleted) {
      deleted.map(function (index) {
        return tableLines.splice(index, 1);
      });
    }

    if (added) {
      added.map(function (item) {
        return tableLines.push(item);
      });
    }

    tableLines.map(function (item, index) {
      return item.index = index;
    });

    _this2.props.onChange(tableLines);
    _this2.setState({ tableLines: tableLines });
  };

  this.EditCell = function (props) {
    var _props2 = _this2.props,
        elements = _props2.schema.elements,
        uiSchema = _props2.uiSchema,
        options = _props2.options;


    var columnElement = elements.find(function (element) {
      return element.key === props.column.name;
    });

    var Component = commandComponents[columnElement.type];

    return Component ? React.createElement(
      "td",
      null,
      React.createElement(Component, {
        element: columnElement,
        options: uiSchema["ui:options"],
        gridProperties: props
      })
    ) : null;
  };

  this.getElementValueByKey = function (element, props) {
    return element.titleMap.find(function (tm) {
      return props.value && tm.value === props.value.toString();
    });
  };

  this.SelectFormatter = function (props) {
    var schema = _this2.props.schema;


    var el = undefined;

    schema.elements.forEach(function (element) {
      if (props.column.name === element.key) {
        var foundElement = _this2.getElementValueByKey(element, props);
        el = foundElement ? foundElement.name : null;
      }
    });

    return React.createElement(
      "span",
      null,
      el
    );
  };
}, _temp);


TableEditableWidget.defaultProps = {
  value: []
};

export default withStyles(tableEditableWidgetStyles)(TableEditableWidget);